import { useState } from 'react';
import { api } from '../api/client';
import { useToast } from '../components/Toast';
import { addPageAction, noticeError } from '../newrelic';

export default function Messaging() {
  const [tab, setTab] = useState('sns');
  const [form, setForm] = useState({ message: '', subject: '', messageGroupId: '' });
  const [submitting, setSubmitting] = useState(false);
  const [lastResponse, setLastResponse] = useState(null);
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setLastResponse(null);

    try {
      const payload =
        tab === 'sns'
          ? { message: form.message, subject: form.subject || undefined }
          : { message: form.message, messageGroupId: form.messageGroupId || undefined };

      const res = tab === 'sns' ? await api.publishSns(payload) : await api.publishSqs(payload);

      addPageAction('message_published', { destination: tab });
      setLastResponse(res);
      toast(`Message sent to ${tab.toUpperCase()}`, 'success');
      setForm({ message: '', subject: '', messageGroupId: '' });
    } catch (err) {
      noticeError(err, { page: 'messaging', destination: tab });
      toast(err.message, 'error');
    } finally {
      setSubmitting(false);
    }
  };

  const tabStyle = (active) => ({
    padding: '0.5rem 1rem',
    border: 'none',
    borderBottom: active ? '2px solid var(--color-primary)' : '2px solid transparent',
    background: 'none',
    color: active ? 'var(--color-primary)' : 'var(--color-text-secondary)',
    fontWeight: active ? 600 : 400,
    cursor: 'pointer',
    fontSize: '0.9rem',
  });

  return (
    <>
      <div className="page-header">
        <h1 className="page-title">Messaging</h1>
        <p className="page-subtitle">Publish messages to AWS SNS topics and SQS queues</p>
      </div>

      <div className="card">
        <div style={{ borderBottom: '1px solid var(--color-border)', marginBottom: '1.25rem' }}>
          <button style={tabStyle(tab === 'sns')} onClick={() => setTab('sns')}>
            SNS Topic
          </button>
          <button style={tabStyle(tab === 'sqs')} onClick={() => setTab('sqs')}>
            SQS Queue
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="label">Message *</label>
            <textarea
              className="input"
              rows={4}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              required
              placeholder="Enter your message"
            />
          </div>

          {tab === 'sns' && (
            <div className="form-group">
              <label className="label">Subject (optional)</label>
              <input
                className="input"
                value={form.subject}
                onChange={(e) => setForm({ ...form, subject: e.target.value })}
                placeholder="Message subject"
              />
            </div>
          )}

          {tab === 'sqs' && (
            <div className="form-group">
              <label className="label">Message Group ID (optional)</label>
              <input
                className="input"
                value={form.messageGroupId}
                onChange={(e) => setForm({ ...form, messageGroupId: e.target.value })}
                placeholder="e.g. my-group"
              />
            </div>
          )}

          <div className="actions actions-right">
            <button className="btn btn-primary" type="submit" disabled={submitting}>
              {submitting && <span className="spinner" />}
              Publish to {tab.toUpperCase()}
            </button>
          </div>
        </form>

        {lastResponse && (
          <div style={{ marginTop: '1.25rem' }}>
            <label className="label">Last Response</label>
            <pre className="json">{JSON.stringify(lastResponse, null, 2)}</pre>
          </div>
        )}
      </div>
    </>
  );
}
